define([
	"csi/datasheet/Splitter",
	"csi/gallery/Splitter",
	"csi/property/Splitter",
	"csi/table/Splitter",
	"csi/view/CompositeSplitter"
], function() {
	
	// must use define rather than require for these to be loaded synchronously
	return {};
});